<template>
  <div :class="['button-group', { active: isActive }]">
    <button
      :class="['button', 'rewind', { disabled: isRewindDisabled }]"
      @click="rewindClicked"
      :tabindex="isRewindDisabled ? -1 : 0"
    >
      <i class="fa fa-backward"></i>
    </button>
    <button
      :class="['button', 'play-pause', 'play', { hide: !isPaused }]"
      @click="playClicked"
      tabindex="0"
    >
      <i class="fa fa-play"></i>
    </button>
    <button
      :class="['button', 'play-pause', 'pause', { hide: isPaused }]"
      @click="pauseClicked"
      tabindex="0"
    >
      <i class="fa fa-pause"></i>
    </button>
    <button
      :class="['button', 'fast-forward', { disabled: isFastForwardDisabled }]"
      @click="fastForwardClicked"
      :tabindex="isFastForwardDisabled ? -1 : 0"
    >
      <i class="fa fa-forward"></i>
    </button>
  </div>
</template>

<script>
  let mediaButtons = {
    name: 'MediaButtons',
    props: {
      isActive: {
        type: Boolean,
        default: true
      },
      isPaused: {
        type: Boolean,
        default: false
      },
      isRewindDisabled: {
        type: Boolean,
        default: false
      },
      isFastForwardDisabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      playClicked: function() {
        /**
         * Play button click event.
         * 
         * @type {none}
         */
        this.$emit('play-clicked');
      },
      pauseClicked: function() {
        /**
         * Pause button click event.
         * 
         * @type {none}
         */
        this.$emit('pause-clicked');
      },
      rewindClicked: function() {
        /**
         * Rewind button click event.
         * 
         * @type {none}
         */
        this.$emit('rewind-clicked');
      },
      fastForwardClicked: function() {
        /**
         * Fast forward button click event.
         * 
         * @type {none}
         */
        this.$emit('fast-forward-clicked');
      }
    }
  };
  export default mediaButtons;
</script>

<style lang="scss" scope>
  .button-group {
    display: inline-block;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */

    &.active {
      .button {
        color: var(--default-color);
        background-color: var(--secondary-btn-bg-color);
        transition: background 0.2s ease-in;
      }
      .button:not(.disabled):hover, .button:not(.disabled):focus {
        background-color: var(--secondary-btn-hover-bg-color);
      }
      .button:not(.disabled) {
        border-color: var(--media-btn-active-border-color);
      }
      .button.disabled {
        color: var(--secondary-btn-color-disabled);
        background-color: var(--secondary-btn-bg-color);
      }
    }

    &:not(.active) {
      .button {
        color: var(--default-color);
        background-color: var(--secondary-btn-bg-color);
        transition: background 0.2s ease-in;
      }
      .button:not(.disabled):hover, .button:not(.disabled):focus {
        background-color: var(--secondary-btn-hover-bg-color);
      }
      .button.disabled {
        color: var(--secondary-btn-color-disabled);
        background-color: var(--secondary-btn-bg-color);
      }
    }

    .button {
      border: 1px solid var(--secondary-btn-border-color);
      min-height: 38px;
      line-height: 38px;
      min-width: 40px;
      display: inline-block;
      margin: 0 1px;
      text-align: center;
      cursor: pointer;
      

      &.disabled {
        cursor: default;
        pointer-events: none;
      }

      &.hide {
        display: none;
      }

      &.rewind {
        border-radius: 24px 0 0 24px;
      }

      &.play-pause {
        width: 65px;
      }

      &.fast-forward {
        border-radius: 0 24px 24px 0;
      }

      i.fa {
        font-size: 14px;
      }
    }
  }
</style>
